import { InjectionToken } from '@angular/core';

// This is used to provide the resulting value of the factory 'service-worker-enabled.factory'.
// It is required because we are providing a non-class (a boolean in this case)
// For more details on Angular dependency injection, please read:
// https://angular.io/guide/dependency-injection#non-class-dependencies
export const SERVICE_WORKER_ENABLED = new InjectionToken<boolean>('SERVICE_WORKER_ENABLED');
